export default "__VITE_ASSET__ZC0P_qPq__"